module.exports = __webpack_public_path__ + "static/18-48791c0ffaa9ba3a6d3b287d0c271c79.jpg";